import { Grid, Stack, Typography } from '@mui/material';
import { APP_IMG } from 'assets';
import { SitterPreviewItem } from 'components';
import { REQUEST_STATUS } from 'features/overview/constant';
import { StyledSittersOverview } from 'features/overview/styled';
import { AC_BASE_REQUEST_SITTER, SITTER_STATUS_LABEL } from 'models/overview';

export const SittersOverView = ({
  acBaseRequestSitters,
}: {
  acBaseRequestSitters: AC_BASE_REQUEST_SITTER[];
}) => {
  return (
    <StyledSittersOverview spacing={2}>
      <Typography variant="Web_Label_18" sx={{ opacity: '50%' }}>
        {acBaseRequestSitters?.some(
          (sitter) => sitter.status === REQUEST_STATUS.accepted,
        )
          ? SITTER_STATUS_LABEL.accepted
          : SITTER_STATUS_LABEL.matched}
      </Typography>
      <Stack spacing={1.5}>
        {acBaseRequestSitters.length > 0 ? (
          acBaseRequestSitters
            .filter(
              (acBaseRequestSitter) => acBaseRequestSitter?.sitter !== null,
            )
            .map((acBaseRequestSitter: AC_BASE_REQUEST_SITTER) => (
              <SitterPreviewItem
                key={acBaseRequestSitter.id}
                acBaseRequestSitter={acBaseRequestSitter}
              />
            ))
        ) : (
          <Grid item xs={12} pb={5}>
            <Stack
              justifyContent="center"
              alignItems="center"
              position="relative"
            >
              <img src={APP_IMG.backgroundEmpty} alt="bg_empty" />
              <Typography
                variant="Web_Label_14"
                position="absolute"
                bottom={10}
                textAlign="center"
                sx={{ width: 326, opacity: 0.5 }}
              >
                We will <b>pair you with compatible Sitter</b>, check back again
                to view the sitters.
              </Typography>
            </Stack>
          </Grid>
        )}
      </Stack>
    </StyledSittersOverview>
  );
};
